<template>
<v-container align="start">
  <transition name="fade-transition" group>
    <div v-if="ready">
      <v-row align="start" justify="start">
        <h2>{{ $t('views.checkout.shipping.shipping') }}</h2>

      </v-row>
      <br>


      <v-row v-for="(rate, key) in shippingRates" align="center" justify="center">
        <v-col justify="start" lg="8" md="12">

          <v-card color="#6f746145" flat outlined ripple style="border:1px solid #6f746180;">

            <v-row align="center">
              <v-col cols="2" align="center">
                <v-icon align="center" justify="center">mdi-truck-fast</v-icon>
              </v-col>
              <v-col cols="5">
                <b>{{rate.carrier_title}}</b>
              </v-col>
              <v-col cols="3">
                <div class="shipping-price">
                  {{rate.formated_price}}
                </div>
              </v-col>
              <v-col cols="2">
                <v-checkbox color="primary" v-if="rate.selected" :disabled="shippingRates.length > 1" v-model="rate.selected" />
                <v-checkbox color="primary" v-if="!rate.selected" v-model="rate.selected" @click="saveShippingMethodToCart(rate.method)" />
              </v-col>
            </v-row>

          </v-card>
        </v-col>
      </v-row>


    </div>
  </transition>
</v-container>
</template>

<script>
// @ is an alias to /src
import CartService from "@/services/CartService.js"
import CustomerService from "@/services/CustomerService.js"
import SaveAddressRequest from "@/packages/Address/src/Models/RequestModels/SaveAddressRequest.js"
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'

export default {
  name: 'shipping',
  components: {
    //
  },
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    address: { required},
    select: { required },
    checkbox: {
      checked (val) {
        return val
      },
    },
  },
  data: () => ({
    ready: false,
    addAddressDialog: false,
    locale: 'en',
    shippingRates: null,
    customer: null,
    lang: {
      1: {
        en: 'Where would you like to deliver to?',
        da: 'Hvor vil du gerne levere til?',
        de: 'Wohin möchten Sie liefern?',
      },
      2: {
        en: 'Deliver to this address',
        da: 'Lever til denne adresse',
        de: 'An diese Adresse liefern',
      },
      3: {
        en: 'Edit',
        da: 'Ret',
        de: 'Redigieren',
      },
      4: {
        en: 'Select Shipping agent:',
        da: 'Vælg fragtoperatør:',
        de: 'Bitte wählen Sie einen Spediteur:',
      },
      5: {
        en: 'Add address',
        da: 'Tilføj adresse',
        de: 'Adresse hinzufügen',
      },
      6: {
        en: 'Shipping',
        da: 'Fragt',
        de: 'Lieferart',
      },
      7: {
        en: 'Go to payment',
        da: 'Gå til betaling',
        de: 'Bezahlung',
      },
      8: {
        en: 'Select',
        da: 'Vælg',
        de: 'wählen',
      },
    },
    shippingAgents: null
  }),
  mounted() {
    this.locale = this.$store.state.app.locale.code;
    this.loadShippingRates();
    this.ready = true;
  },
  computed: {
    cart() {
      return this.$store.state.checkout.cart
    },
  },
  watch: {
    shippingRates() {
      for (var i = 0; i < this.shippingRates.length; i++) {
        if (this.cart.selected_shipping_rate) {
          if (this.shippingRates[i].method === this.cart.selected_shipping_rate.method) {
            this.shippingRates[i].selected = true;
          }
        }
      }
    }
  },
  methods: {
    async loadShippingRates() {
      this.shippingRates = this.$store.state.checkout.cart.shipping_rates;
      // for (var i = 0; i < this.shippingRates.length; i++) {
      //   if (this.shippingRates[i].method === this.cart.selected_shipping_rate.method) {
      //     this.shippingRates[i].selected = true;
      //   }
      // }
    },
    saveShippingMethodToCart(shippingMethod) {

      this.saveAddressToCart();

      // Mark the shipping method as selected
      CartService.saveShippingMethodToCart(shippingMethod)
      .then(response => {
        this.loadShippingRates();
      }).catch(error => {
        console.log(error);
      })

      // Save the payment method too.. it's stripe
    },
    saveAddressToCart() {
      // Create an instance of SaveAddressRequest()
      let saveAddressRequestPayload = new SaveAddressRequest(this.$store.state.checkout.billingAddress.address, this.$store.state.checkout.shippingAddress.address);

      CartService.saveAddressToCart(saveAddressRequestPayload)
      .then(response => {
        console.log(response);
      }).catch(error => {
        console.log(error);
      })

      // Save the payment method too.. it's stripe
    },
    goToPayment() {
      // Push to payment..
      this.$router.push({ path: '/checkout/payment' })
    }
  }
};
</script>

<style>
  .fade-me-enter-active, .fade-me-leave-active {
    transition: opacity 1.5s;
  }
  .fade-me-enter, .fade-me-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  }

  .shipping-price {
    font-weight: bold;
    color: green;
  }
</style>
